import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [token, setToken] = useState(() => localStorage.getItem("sms_token") || "");

  useEffect(() => {
    (async () => {
      if (!token) {
        setUser(false);
        return;
      }
      try {
        // Jeśli już mamy użytkownika (np. właśnie się zalogowaliśmy), nie pobieraj go ponownie
        if (user && user.token === token) return;

        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        console.error("Auth error", e);
        // Jeśli błąd to 401, wyczyść token
        if (e.response?.status === 401) {
          localStorage.removeItem("sms_token");
          setToken("");
        }
        setUser(false);
      }
    })();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data && data.token) {
      localStorage.setItem("sms_token", data.token);
      setToken(data.token);
      setUser(data);
      return data;
    }
    // Jeśli API zwróciło 200 OK, ale bez tokenu, traktujemy to jako błąd
    throw new Error("Serwer nie zwrócił klucza dostępu. Sprawdź konfigurację API.");
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn(e);
    }
    localStorage.removeItem("sms_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
